import { Model, Store } from 'store/Base';
import { observable } from 'mobx';
import { Contact } from './Contact';
import { Subproject } from './Subproject';
import { TicketRelationStore } from './TicketRelation';

export class Ticket extends Model {
    static backendResourceName = 'ticket';
    static omitFields = ['fullName', 'timeSpent', 'aiSpend', 'aiHours']

    @observable id = null;
    @observable number = 0;
    @observable title = '';

    // T1234 - FOO BAR (annotation on backend)
    @observable fullName = ''

    // Planned time from Phabricator estimate (duration) fields, in minutes
    @observable estimatedTimeInMinutes = null;

    // Timespent on the ticket in seconds
    @observable timeSpent = 0;

    // AI spend via Synapse (annotation on backend)
    @observable aiSpend = 0;

    // AI request time via Synapse (annotation on backend), in seconds
    @observable aiHours = 0;

    // Planned time from Phabricator estimate (duration) fields, in minutes
    @observable estimatedTimeInMinutes = null;

    @observable assignedTo = this.relation(Contact);

    // [T53675] Optional link to a sub project: registering time on this
    // ticket auto selects the sub project in the time registration form.
    @observable subproject = this.relation(Subproject);

    @observable parentRelations = this.relation(TicketRelationStore);

    @observable childRelations = this.relation(TicketRelationStore);
}

export class TicketStore extends Store {
    Model = Ticket;
    static backendResourceName = 'ticket';
}
